export default {
  fi: {
    ResetSuccessScene: {
      passwordUpdated: 'Salasanasi on päivitetty.',
      backLink: 'Takaisin kirjautumissivulle',
    },
  },
};
